// ======================================================================
// File: src/modules/ppe/transport/shared/TransportStatusBadge.jsx
// Module: PPE → Transport
// Purpose:
//   Reusable status badge for Transport lifecycle display
// ======================================================================

import React from "react";


// ----------------------------------------------------------------------
// STATUS COLOR MAP
// (can later come from Status Master API)
// ----------------------------------------------------------------------
const STATUS_STYLE = {
  REQUESTED: "bg-secondary",
  BOOKING_PENDING: "bg-warning text-dark",
  BOOKED: "bg-primary",
  PICKED_UP: "bg-info text-dark",
  IN_TRANSIT: "bg-info",
  DELIVERED: "bg-success",
  CLOSED: "bg-dark",
};


// ======================================================================
// COMPONENT
// ======================================================================

export default function TransportStatusBadge({ status }) {

  if (!status) return null;

  const className =
    STATUS_STYLE[status] || "bg-secondary";

  return (
    <span className={`badge ${className}`}>
      {status.replaceAll("_", " ")}
    </span>
  );
}
